import React, { useEffect, useState } from "react";
import "./contactUs.scss";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import { contactUsURL } from "../../helpers/paths";
import { callIcon, locationIcon, msgIcon } from "../../source";
import KnowMore from "../../components/KnowMore/KnowMore";
import Joi from "joi";
import config from "../../config/config";
import http from "../../helpers/http";
import helper from "../../helpers/helper";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

const ContactUs = () => {
  const [inputValue, setInputValue] = useState({
    name: "",
    companyName:"",
    emailId: "",
    description: "",
    designation: "",
    phoneNumber: "",
    industrySector: "",
    drawingDetails: "",
    materialDetails: "",
    coatingDetails: "",
    applicationEnvironment: "",
    problemStatement: "",
    surfaceFinish: "",
    commercialDetails: "",
    message: "",
  });

  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  // const [consent, setConsent] = useState(false);

  let base_url = config.api_url + "/forms/contact";
  let sizeLimit = 10;

  const navigate = useNavigate();

  const schema = Joi.object({
    name: Joi.string().trim().required().label("Name"),
    companyName: Joi.string().trim().required().label("Company Name"),
    emailId: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .label("Email ID"),
    // description: Joi.string().trim().required().label("Description"),
    designation: Joi.string().trim().required().label("Designation"),
    phoneNumber: Joi.string()
    // .length(10)
    // .pattern(/^[0-9]+$/)
    .pattern(/^[0-9+\-\s]+$/)
    .messages({ "string.pattern.base": `Phone number must be number.`,"string.length": `Phone number must have 10 digits.` })
    .required()
    .label("Phone Number"),

    industrySector: Joi.string().trim().required().label("Industry Sector"),
    // drawingDetails: Joi.string().trim().required().label("Drawing Details"),
    // materialDetails: Joi.string().trim().required().label("Material Details"),
    // coatingDetails: Joi.string().trim().required().label("Coating Details"),
    // applicationEnvironment: Joi.string().trim().required().label("Application Environment"),
    // problemStatement: Joi.string().trim().required().label("Problem Statement"),
    // surfaceFinish: Joi.string().trim().required().label("Surface Finish"),
    // commercialDetails: Joi.string()
    //   .trim()
    //   .required()
    //   .label("Commercial Details"),
    message: Joi.string().trim().required().label("Message"),

   

    // message: Joi.string().trim().label("Message"),
  }).options({ allowUnknown: true });

  const validate = async (data) => {
    const { error } = schema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
      errors: {
        wrap: {
          label: "",
        },
      },
    });

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }
  
    if (inputValue.drawingDetails) {
      if (inputValue.drawingDetails.size > sizeLimit * 1024 * 1024) {
        errors["drawingDetails"] = `File needs to be under ${sizeLimit} MB`;
      }
      let allowedExt = [
        "dxf",
       
      ];
      if (!allowedExt.includes(inputValue.drawingDetails.name.split('.').pop().toLowerCase())) {
        errors["drawingDetails"] = "Please upload valid file type";
      }
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    console.log("form submit");

    e.preventDefault();
    // console.log(values);
    let errors = await validate(inputValue);
    setFormError(errors);

    console.log({ errors });
    if (Object.keys(errors).length) {
      helper.scroll(helper.getFirstError(errors));
      return;
    }

    setLoading(true);


    let formData = new FormData();
    for (const [key, data] of Object.entries(
      _.omit(inputValue, ["drawingDetails"])
    )) {
      formData.append(key, data || "");
    }

    
    if (inputValue.drawingDetails) {
      formData.append("drawingDetails", inputValue.drawingDetails);
    }

    // console.log(...formData);
    // return;

    const { data } = await http.post(base_url, formData);

    if (data) {
      setInputValue({
        name: "",
        companyName: "",
        emailId: "",
        description: "",
        designation: "",
        phoneNumber: "",
        industrySector: "",
        // drawingDetails: "",
        materialDetails: "",
        coatingDetails: "",
        applicationEnvironment: "",
        problemStatement: "",
        surfaceFinish: "",
        commercialDetails: "",
        message: "",
      });
      navigate("/contact-thank-you");
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    if (e.target.type == "file") {
      setInputValue((prevState) => {
        return {
          ...prevState,
          [e.target.name]: e.target.files[0],
        };
      });
    } else {
      setInputValue((prevState) => {
        return {
          ...prevState,
          [e.target.name]: e.target.value,
        };
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonBanner link={contactUsURL} text="Contact Us" title="Contact Us" />
      <section className="contact_sec1">
        <div className="my_container">
          <div className="row contact_row">
            <div className="col-lg-6 contact_col" data-aos="fade">
              <div className="contact_details">
                <div className="content_wrapper">
                  <div className="icon_wrapper">
                    <img src={msgIcon} alt="message" className="icon" />
                  </div>
                  <div className="contact_data">
                    <h2 className={`title `}>Email</h2>
                    <p className="desc">
                      <a href="mailto:info@kapindra.com" className="link">
                        info@kapindra.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="content_wrapper">
                  <div className="icon_wrapper">
                    <img src={callIcon} alt="message" className="icon" />
                  </div>
                  <div className="contact_data">
                    <h2 className={`title `}>Contact number: </h2>
                    <p className="desc">
                      <a href="tel:+919147016162" className="link">
                        +91 9147 016 162
                      </a>
                      {/* <a href="tel:+91-22-26862828" className="link">
                        26862828 {" / "}
                      </a>
                      <a href="tel:+91-22-26862929" className="link">
                        26862929
                      </a> */}
                    </p>
                  </div>
                </div>
                <div className="content_wrapper">
                  <div className="icon_wrapper">
                    <img src={locationIcon} alt="message" className="icon" />
                  </div>
                  <div className="contact_data">
                    <h2 className={`title `}>Address:</h2>
                    <p className="desc">
                      <a
                        href="https://maps.app.goo.gl/PdKHscGkWevqPavk6"
                        target="_blank"
                        rel="noreferrer"
                        className="link add_link"
                      >
                        Kapindra Precision Engineering Pvt Ltd
                        <br />
                        D1-02, 1st Floor, IIT Madras Research Park,
                        <br />
                        Kanagam Road, Taramani, Chennai - 600113, Tamil Nadu,
                        India.
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 contact_col" data-aos="fade">
              <div className="map_wrapper">
                <iframe
                  title="google map frame"
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d9608.421628036896!2d80.24239759512747!3d12.991263488121877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU5JzI1LjgiTiA4MMKwMTQnMzMuNyJF!5e0!3m2!1sen!2sin!4v1737106037295!5m2!1sen!2sin"
                  width="100%"
                  height="454"
                  style={{ border: "0", margin: "0", padding: "0" }}
                  allowFullScreen
                  loading="lazy"
                  className="map_frame"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact_sec2">
        <div className="my_container">
          <div className="head_wrapper">
            <h2 className="heading" data-aos="fade-up">
              Customer Inquiry
            </h2>
            <p className="decription" data-aos="fade-up">
              If you wish to make a technical enquiry or to receive a quotation
              for samples then please provide us with as much of the following
              information as possible:
            </p>
          </div>
          <form className="form_wrapper" onSubmit={handleSubmit} noValidate>
            <div className="input_container" data-aos="fade-up">
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.name.length > 0 ? "active" : ""
                  }`}
                >
                  Name*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.name.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="name"
                  value={inputValue.name}
                  onChange={handleInputChange}
                />
                <p className="error" id="name_error">{formError.name}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.companyName.length > 0 ? "active" : ""
                  }`}
                >
                  Company Name*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.companyName.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="companyName"
                  value={inputValue.companyName}
                  onChange={handleInputChange}
                />
                <p className="error">{formError.companyName}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.emailId.length > 0 ? "active" : ""
                  }`}
                >
                  Email Id*
                </h2>
                <input
                  type="email"
                  className={`input_field ${
                    inputValue.emailId.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="emailId"
                  value={inputValue.emailId}
                  onChange={handleInputChange}
                />
                <p className="error" id="emailId_error">{formError.emailId}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.designation.length > 0 ? "active" : ""
                  }`}
                >
                  Designation*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.designation.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="designation"
                  value={inputValue.designation}
                  onChange={handleInputChange}
                />
                <p className="error" id="designation_error">{formError.designation}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.phoneNumber.length > 0 ? "active" : ""
                  }`}
                >
                  Phone Number*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.phoneNumber.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="phoneNumber"
                  value={inputValue.phoneNumber}
                  onChange={handleInputChange}
                />
                <p className="error" id="phoneNumber_error">{formError.phoneNumber}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.industrySector.length > 0 ? "active" : ""
                  }`}
                >
                  Industry Sector*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.industrySector.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="industrySector"
                  value={inputValue.industrySector}
                  onChange={handleInputChange}
                />
                <p className="error" id="industrySector_error">{formError.industrySector}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.description.length > 0 ? "active" : ""
                  }`}
                >
                  Component Description
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.description.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="description"
                  value={inputValue.description}
                  onChange={handleInputChange}
                />
                <p className="error" id="description_error">{formError.description}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.drawingDetails.length > 0 ? "active" : ""
                  }`}
                >
                  Component drawing or overall dimensions (.dxf file be
                  attached)
                </h2>
                <input
                  type="file"
                  hidden
                  id="file-upload"
                  className={`input_field`}
                  name="drawingDetails"
                  accept=".dxf"
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="file-upload"
                  className="input_field upload_label"
                >
                  {inputValue.drawingDetails
                    ? inputValue.drawingDetails.name
                    : "Select File"}
                </label>
                <p className="error" id="drawingDetails_error">{formError.drawingDetails}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.materialDetails.length > 0 ? "active" : ""
                  }`}
                >
                  Component material details (with elemental composition if
                  possible)
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.materialDetails.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="materialDetails"
                  value={inputValue.materialDetails}
                  onChange={handleInputChange}
                />
                <p className="error" id="materialDetails_error">{formError.materialDetails}</p>
              </div>

              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.coatingDetails.length > 0 ? "active" : ""
                  }`}
                >
                  Details of any existing coating and expected surface finish of
                  coating to be coated
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.coatingDetails.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="coatingDetails"
                  value={inputValue.coatingDetails}
                  onChange={handleInputChange}
                />
                <p className="error" id="coatingDetails_error">{formError.coatingDetails}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.applicationEnvironment.length > 0 ? "active" : ""
                  }`}
                >
                  Application environment (load, media, abrasives, etc)
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.applicationEnvironment.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="applicationEnvironment"
                  value={inputValue.applicationEnvironment}
                  onChange={handleInputChange}
                />
                <p className="error" id="applicationEnvironment_error">{formError.applicationEnvironment}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.problemStatement.length > 0 ? "active" : ""
                  }`}
                >
                  Problem you are seeking to solve or characteristics you wish
                  to enhance (eg: lifetime)
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.problemStatement.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="problemStatement"
                  value={inputValue.problemStatement}
                  onChange={handleInputChange}
                />
                <p className="error" id="problemStatement_error">{formError.problemStatement}</p>
              </div>

              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.surfaceFinish.length > 0 ? "active" : ""
                  }`}
                >
                  Surface finish of component/substrate (both sought and
                  provided)
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.surfaceFinish.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="surfaceFinish"
                  value={inputValue.surfaceFinish}
                  onChange={handleInputChange}
                />
                <p className="error" id="surfaceFinish_error">{formError.surfaceFinish}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.commercialDetails.length > 0 ? "active" : ""
                  }`}
                >
                  Commercial details (annual usage, batch size, target price)
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.commercialDetails.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="commercialDetails"
                  value={inputValue.commercialDetails}
                  onChange={handleInputChange}
                />
                <p className="error" id="commercialDetails_error">{formError.commercialDetails}</p>
              </div>
              <div className="input_wrapper">
                <h2
                  className={`title ${
                    inputValue.message.length > 0 ? "active" : ""
                  }`}
                >
                  Message*
                </h2>
                <input
                  type="text"
                  className={`input_field ${
                    inputValue.message.length > 0 ? "active" : ""
                  }`}
                  placeholder="Enter Here"
                  name="message"
                  value={inputValue.message}
                  onChange={handleInputChange}
                />
                <p className="error" id="message_error">{formError.message}</p>
              </div>
            </div>
            <div
              className="cta_wrapper"
              // data-aos="fade-up"
            >
              {/* <button type="submit" >Submit</button> */}
              <KnowMore button text="Submit" />
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
